import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaPlus, FaList, FaChevronLeft, FaChevronRight, FaSignOutAlt } from 'react-icons/fa';
import './Home.css';
import Logo from "../assets/logoapp.png";
import { apiGet } from '../services/api';

function Home() {
  const [username, setUsername] = useState('');
  const [records, setRecords] = useState([]);
  const [units, setUnits] = useState({});
  const [locais, setLocais] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 12;
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    const name = localStorage.getItem('userName');
    const colaboradorId = localStorage.getItem('colaboradorId');

    if (!token || !colaboradorId) {
      navigate('/login');
    } else {
      setUsername(name || 'Usuário');
      fetchData(parseInt(colaboradorId, 10));
    }
  }, [navigate]);

  const fetchData = async (colaboradorId) => {
    setIsLoading(true);
    try {
      const [{ data: unitsData }, { data: locaisData }, { data: recordsData }] = await Promise.all([
        apiGet('/units'),
        apiGet('/locais'),
        apiGet(`/registros?filters[0][0]=obser&filters[0][1]==&filters[0][2]=${colaboradorId}&filters[1][0]=app_registro_id&filters[1][1]==&filters[1][2]=1`),
      ]);

      if (unitsData.status === 'success') {
        const unitMap = unitsData.data.reduce((map, unit) => {
          map[unit.id] = unit.nome;
          return map;
        }, {});
        setUnits(unitMap);
      }

      if (locaisData.status === 'success') {
        const locaisMap = locaisData.data.reduce((map, local) => {
          map[local.id] = local.nome;
          return map;
        }, {});
        setLocais(locaisMap);
      }

      if (recordsData.status === 'success') {
        // Ordenar do mais recente para o mais antigo
        const sortedRecords = recordsData.data.sort((a, b) => {
          return new Date(b.datapoc) - new Date(a.datapoc);
        });
        setRecords(sortedRecords);
      }
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const formatDate = (dateString) => {
    // Corrige problema de fuso horário dividindo a string da data
    const [ano, mes, dia] = dateString.split('-');
    const date = new Date(ano, mes - 1, dia); // mes - 1 porque Date usa 0-11 para meses
    return date.toLocaleDateString('pt-BR');
  };

  // Calcular indicadores
  const totalRegistros = records.length;
  
  const registrosNesteMes = records.filter((record) => {
    const [ano, mes] = record.datapoc.split('-');
    const dataAtual = new Date();
    const anoAtual = dataAtual.getFullYear();
    const mesAtual = dataAtual.getMonth() + 1;
    return parseInt(ano) === anoAtual && parseInt(mes) === mesAtual;
  }).length;

  const ultimoRegistro = records.length > 0 ? formatDate(records[0].datapoc) : 'Nenhum registro';

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userName');
    localStorage.removeItem('colaboradorId');
    navigate('/login');
  };

  const handleNovaSugestaoClick = () => {
    navigate('/fique-atento');
  };

  const handleCardClick = (recordId) => {
    navigate(`/preview/${recordId}`);
  };

  // Cálculos de paginação
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = records.slice(indexOfFirstRecord, indexOfLastRecord);
  const totalPages = Math.ceil(records.length / recordsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <div className="home-container">
      {/* Header fixo */}
      <header className="header">
        <div className="logo-section">
          <img src={Logo} alt="Fique Atento" className="logo-image" />
        </div>
        <div className="header-buttons">
          <button onClick={handleNovaSugestaoClick} className="btn-novo-registro">
            <FaPlus /> Novo Registro
          </button>
          <button onClick={handleLogout} className="btn-meus-registros">
            <FaSignOutAlt /> Logout
          </button>
        </div>
      </header>

      {/* Conteúdo principal */}
      <main className="main-content">
        <div className="page-header">
          <h2>Meus Registros</h2>
          <button onClick={handleNovaSugestaoClick} className="btn-novo-mobile">
            <FaPlus /> Novo Registro
          </button>
        </div>

        {/* Cards de Indicadores */}
        {!isLoading && (
          <div className="indicators-grid">
            <div className="indicator-card">
              <div className="indicator-icon total">
                <FaList />
              </div>
              <div className="indicator-content">
                <span className="indicator-label">Total de Registros</span>
                <span className="indicator-value">{totalRegistros}</span>
              </div>
            </div>

            <div className="indicator-card">
              <div className="indicator-icon month">
                <FaPlus />
              </div>
              <div className="indicator-content">
                <span className="indicator-label">Registros Neste Mês</span>
                <span className="indicator-value">{registrosNesteMes}</span>
              </div>
            </div>

            <div className="indicator-card">
              <div className="indicator-icon last">
                <FaChevronRight />
              </div>
              <div className="indicator-content">
                <span className="indicator-label">Último Registro</span>
                <span className="indicator-value">{ultimoRegistro}</span>
              </div>
            </div>
          </div>
        )}

        {isLoading ? (
          <div className="loading-spinner">
            <div className="spinner"></div>
            <p>Carregando...</p>
          </div>
        ) : records.length > 0 ? (
          <>
            <div className="records-grid">
              {currentRecords.map((record) => (
                <div 
                  key={record.id} 
                  className="record-card"
                  onClick={() => handleCardClick(record.id)}
                >
                  <div className="card-content">
                    <div className="card-row">
                      <span className="card-label">Data:</span>
                      <span className="card-value">{formatDate(record.datapoc)}</span>
                    </div>
                    <div className="card-row">
                      <span className="card-label">Unidade:</span>
                      <span className="card-value">{units[record.unidades_id] || 'Unidade Desconhecida'}</span>
                    </div>
                    <div className="card-row">
                      <span className="card-label">Local:</span>
                      <span className="card-value">{locais[record.locais_id] || 'Local Desconhecido'}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Paginação */}
            {totalPages > 1 && (
              <div className="pagination">
                <button 
                  onClick={handlePreviousPage} 
                  disabled={currentPage === 1}
                  className="pagination-btn"
                >
                  <FaChevronLeft />
                </button>
                
                <div className="pagination-numbers">
                  {[...Array(totalPages)].map((_, index) => {
                    const pageNumber = index + 1;
                    // Mostrar apenas páginas relevantes (atual, vizinhas, primeira e última)
                    if (
                      pageNumber === 1 ||
                      pageNumber === totalPages ||
                      (pageNumber >= currentPage - 1 && pageNumber <= currentPage + 1)
                    ) {
                      return (
                        <button
                          key={pageNumber}
                          onClick={() => handlePageChange(pageNumber)}
                          className={`pagination-number ${currentPage === pageNumber ? 'active' : ''}`}
                        >
                          {pageNumber}
                        </button>
                      );
                    } else if (
                      pageNumber === currentPage - 2 ||
                      pageNumber === currentPage + 2
                    ) {
                      return <span key={pageNumber} className="pagination-ellipsis">...</span>;
                    }
                    return null;
                  })}
                </div>

                <button 
                  onClick={handleNextPage} 
                  disabled={currentPage === totalPages}
                  className="pagination-btn"
                >
                  <FaChevronRight />
                </button>
              </div>
            )}
          </>
        ) : (
          <div className="empty-state">
            <FaList className="empty-icon" />
            <p>Nenhum registro encontrado para este colaborador.</p>
            <button onClick={handleNovaSugestaoClick} className="btn-novo-registro">
              <FaPlus /> Criar Primeiro Registro
            </button>
          </div>
        )}
      </main>
    </div>
  );
}

export default Home;